<ng-template #productDetailContainer></ng-template>
